var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 17c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75H4.75a.75.75 0 0 0-.75.75c0 .416.334.75.75.75zm-5.797-4.238a.748.748 0 0 0 1.094 0l4-4.25a.75.75 0 0 0-1.09-1.028L10.75 10.36V3.75A.75.75 0 0 0 10 3a.75.75 0 0 0-.75.75v6.61L6.547 7.487a.75.75 0 0 0-1.09 1.028l4 4.25z"
  })));
};
export default SvgDownload;